import type { ReactNode } from 'react';
import {
  HomeIcon,
  FolderIcon,
  UsersIcon,
  CogIcon,
  ChartBarIcon,
  GitBranchIcon,
  LayoutDashboardIcon,
  KanbanIcon,
  ShieldCheckIcon,
  SitemapIcon,
  ActivityIcon,
  DatabaseIcon,
  TableIcon,
  ClockIcon,
  ClipboardDocumentListIcon,
  DocumentTextIcon,
  CommandLineIcon,
  FlagIcon,
  LinkIcon,
  MapPinIcon,
  BookOpenIcon,
  ChatBubbleIcon,
} from '@/components/ui';
import type { IconKey } from './types';

/**
 * Icon registry mapping string keys to React icon components.
 * Add new icons here to make them available in navigation config.
 */
export const iconRegistry: Record<IconKey, () => ReactNode> = {
  home: () => <HomeIcon />,
  folder: () => <FolderIcon />,
  users: () => <UsersIcon />,
  cog: () => <CogIcon />,
  'chart-bar': () => <ChartBarIcon />,
  'git-branch': () => <GitBranchIcon />,
  'layout-dashboard': () => <LayoutDashboardIcon />,
  kanban: () => <KanbanIcon />,
  'shield-check': () => <ShieldCheckIcon />,
  sitemap: () => <SitemapIcon />,
  activity: () => <ActivityIcon />,
  database: () => <DatabaseIcon />,
  table: () => <TableIcon />,
  clock: () => <ClockIcon />,
  'clipboard-list': () => <ClipboardDocumentListIcon />,
  'document-text': () => <DocumentTextIcon />,
  'command-line': () => <CommandLineIcon />,
  flag: () => <FlagIcon />,
  link: () => <LinkIcon />,
  'map-pin': () => <MapPinIcon />,
  'book-open': () => <BookOpenIcon />,
  'chat-bubble': () => <ChatBubbleIcon />,
};

/**
 * Get icon component by key
 * @throws Error if icon key is not found
 */
export function getIcon(key: IconKey): ReactNode {
  const iconFactory = iconRegistry[key];
  if (!iconFactory) {
    throw new Error(
      `[Navigation Config Error] Unknown icon key: "${key}". ` +
      `Available icons: ${Object.keys(iconRegistry).join(', ')}`
    );
  }
  return iconFactory();
}

